var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.101 23.647V15.667H6.627V12H9.101V10.42C9.101 6.335 10.949 4.442 14.959 4.442C15.36 4.442 15.914 4.484 16.427 4.545C16.8112 4.58454 17.1924 4.64968 17.568 4.74V8.065C17.3509 8.04475 17.133 8.03274 16.915 8.029C16.6707 8.02266 16.4264 8.01966 16.182 8.02C15.475 8.02 14.923 8.116 14.507 8.329C14.2273 8.46931 13.9922 8.68468 13.828 8.951C13.57 9.371 13.454 9.946 13.454 10.703V12H17.373L16.987 14.103L16.7 15.667H13.454V23.912C19.396 23.194 24 18.135 24 12C24 5.373 18.627 0 12 0C5.373 0 0 5.373 0 12C0 17.628 3.874 22.35 9.101 23.647Z",
    fill: "#403194"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.13400dde352fa28021643af6f4a3d171.svg";
export { ForwardRef as ReactComponent };